"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledFacilitiesList = exports.StyledFacilitiesItem = exports.StyledFacilitiesHeader = exports.NO_INFO_TEXT = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _localization = require("@lt/localization");

var _FacilitiesItem = _interopRequireDefault(require("../FacilitiesItem"));

var _hotel = require("../../proptypes/hotel");

var _HotelFacilitiesPopup = _interopRequireDefault(require("../HotelFacilitiesPopup/HotelFacilitiesPopup"));

var _excluded = ["facilities", "description", "hotelFacilities", "isMobile"];

var NO_INFO_TEXT = _localization.i18n.t('hotel.room.noInfo');

exports.NO_INFO_TEXT = NO_INFO_TEXT;

var HotelRoomFacilities = function HotelRoomFacilities(_ref) {
  var facilities = _ref.facilities,
      description = _ref.description,
      hotelFacilities = _ref.hotelFacilities,
      isMobile = _ref.isMobile,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var disabled = rest.disabled,
      className = rest.className;

  var _useTranslation = (0, _localization.useTranslation)(),
      t = _useTranslation.t;

  var hasFacilities = !(0, _isEmpty2["default"])(facilities);
  var noInfo = !(description || hasFacilities);
  return /*#__PURE__*/_react["default"].createElement("div", {
    disabled: disabled,
    className: className
  }, (description || noInfo) && /*#__PURE__*/_react["default"].createElement(StyledDescription, {
    noInfo: noInfo
  }, noInfo ? NO_INFO_TEXT : description), hasFacilities && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledFacilitiesHeader, null, "".concat(t('hotel.room.inRoom'), ":")), /*#__PURE__*/_react["default"].createElement(StyledFacilitiesList, {
    isMobile: isMobile
  }, facilities.map(function (_ref2) {
    var name = _ref2.name,
        type = _ref2.group_identifier;
    return name ? /*#__PURE__*/_react["default"].createElement(StyledFacilitiesItem, {
      key: name,
      showCheck: true,
      icon: type
    }, name) : null;
  }))), !(0, _isEmpty2["default"])(hotelFacilities) && /*#__PURE__*/_react["default"].createElement(StyledHotelFacilitiesPopup, {
    items: hotelFacilities,
    isMobile: isMobile
  }));
};

var StyledFacilitiesList = _styledComponents["default"].div.withConfig({
  displayName: "HotelRoomFacilities__StyledFacilitiesList",
  componentId: "sc-4m6iju-0"
})(["margin-top:3px;", ""], function (props) {
  return !props.isMobile && "\n  display: flex;\n  flex-wrap: wrap;\n  > li {\n    flex-basis: 50%;\n  }\n  ";
});

exports.StyledFacilitiesList = StyledFacilitiesList;
var StyledFacilitiesItem = (0, _styledComponents["default"])(_FacilitiesItem["default"]).withConfig({
  displayName: "HotelRoomFacilities__StyledFacilitiesItem",
  componentId: "sc-4m6iju-1"
})(["", ";color:", ";flex-basis:50%;"], function (props) {
  return props.theme.typography.text3;
}, function (props) {
  return props.theme.colors.blackLight;
});
exports.StyledFacilitiesItem = StyledFacilitiesItem;

var StyledFacilitiesHeader = _styledComponents["default"].div.withConfig({
  displayName: "HotelRoomFacilities__StyledFacilitiesHeader",
  componentId: "sc-4m6iju-2"
})(["margin-top:13px;", ";color:", ";font-weight:bold;"], function (props) {
  return props.theme.typography.headline7;
}, function (props) {
  return props.theme.colors.blackBase;
});

exports.StyledFacilitiesHeader = StyledFacilitiesHeader;

var StyledDescription = _styledComponents["default"].div.withConfig({
  displayName: "HotelRoomFacilities__StyledDescription",
  componentId: "sc-4m6iju-3"
})(["", ";color:", ";"], function (props) {
  return props.theme.typography.text1;
}, function (props) {
  return props.noInfo ? props.theme.colors.greyLight : props.theme.colors.blackLight;
});

var StyledHotelFacilitiesPopup = (0, _styledComponents["default"])(_HotelFacilitiesPopup["default"]).withConfig({
  displayName: "HotelRoomFacilities__StyledHotelFacilitiesPopup",
  componentId: "sc-4m6iju-4"
})(["margin-top:40px;"]);
HotelRoomFacilities.propTypes = {
  facilities: _propTypes["default"].arrayOf(_hotel.RoomFacilityPropTypes),
  hotelFacilities: _propTypes["default"].arrayOf(_hotel.RoomFacilityPropTypes),
  description: _propTypes["default"].string,
  isMobile: _propTypes["default"].bool
};
HotelRoomFacilities.defaultProps = {
  facilities: null,
  hotelFacilities: null,
  description: null,
  isMobile: false
};

var _default = /*#__PURE__*/_react["default"].memo(HotelRoomFacilities);

exports["default"] = _default;